// La vignette d'un groupe ou d'une page, dans une liste.
//
// Les deux se ressemblent assez pour partager un composant : une image (ou un
// emblème à défaut), un nom, une ligne de précision. Ce qui les sépare tient
// dans deux lignes — un groupe a un responsable, une page a des abonnés — et
// c'est le seul endroit où cette différence doit s'écrire.
//
// L'étiquette et l'emblème viennent de `espaces-meta.js`, qui ne dépend de rien
// et que lisent aussi bien les écrans React que ceux encore en HTML.

import { typeDe, categorieDe } from "../espaces-meta.js";
import Certifie from "./Certifie.jsx";

/**
 * @param {object} p
 * @param {object} p.espace      un groupe ou une page
 * @param {"groupe"|"page"} p.genre
 * @param {boolean} p.description  afficher la description (non dans les aperçus)
 */
export default function CarteEspace({ espace, genre, description = true }) {
  const page = genre === "page";
  const meta = page ? categorieDe(espace.categorie) : typeDe(espace.type);

  // Le rôle du membre, dit dans les mots de l'endroit
  let role = "";
  if (page) role = espace.monRole === "admin" ? " · vous administrez" : espace.monRole ? " · abonné" : "";
  else role = espace.monRole === "responsable" ? " · responsable" : "";

  return (
    <a className="groupe" href={`#/${page ? "page" : "groupe"}/${espace.id}`}>
      <span
        className="groupe__image"
        style={espace.image ? { backgroundImage: `url('${espace.image}')` } : undefined}
      >
        {espace.image ? "" : meta.icone}
      </span>
      <span className="groupe__texte">
        <strong>
          {espace.nom}
          {/* Une page se certifie comme un membre ; un groupe, non — un groupe
              n'a pas de voix publique à authentifier. */}
          {page && <Certifie membre={espace} taille={13} />}
        </strong>
        <span className="petit texte-doux">
          {meta.label}
          {role}
        </span>
        {description && espace.description && (
          <span className="groupe__desc petit">{espace.description}</span>
        )}
      </span>
    </a>
  );
}
